<template>
  <div class="emit-value-component">
    <label for="value"></label>
    <input type="text" id="value" v-model="emittedValue" />
    <button @click="emitValue">Emit Value!!</button>
  </div>
</template>

<script>
import Vue from 'vue'
import { value } from 'vue-function-api'

export default {
  name: 'EmitValueComponent',
  setup(props, context) {
    const emittedValue = value('Hello!')
    const emitValue = () => context.emit('emit-value', emittedValue.value)

    return {
      emitValue,
      emittedValue
    }
  }
}
</script>
